import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import il18n from './lang/i18n.js'
import router from './router/index.js'
import Vuex from 'vuex'
import store from '@/store/index'
import lazyLoad from './directives/lazyLoad'
import track from './directives/track'
import '@/assets/styles/main.scss'
import '/public/fonts/font.css'
import { memcorePinia } from './views/memcore/pinia'
import { installChunkRecovery } from './utils/chunkRecovery'
import { installLoginBackRecovery } from './utils/loginBackRecovery'


const app = createApp(App)
installChunkRecovery(router)
installLoginBackRecovery()
app.directive('lazy', lazyLoad)
app.directive('track', track)

app.use(memcorePinia).use(router).use(il18n).use(Vuex).use(store).mount('#app')
